export function telephoneNumber(phone: string | null): string {
  if (!phone) {
    return "";
  }

  return `tel:${phone.replace(/\D/g, "")}`;
}
